import { ILanguageSwitcherLanguage } from '@hg/stylizator/components'

import { IResponseMenuItem, TReusableBlock } from 'app/service/api/theme'

export interface IStore {
  menu: IResponseMenuItem[]
  footerMenu: IResponseMenuItem[][]
  honeygainCleanMenu: IResponseMenuItem[]
  honeygainReferralMeMenu: IResponseMenuItem[]
  honeygainReferralIoMenu: IResponseMenuItem[]
  carebuzzMenu?: IResponseMenuItem[]
  carebuzzFooterMenu?: IResponseMenuItem[][]
  swarmbytesFooterMenu?: IResponseMenuItem[][]
  honeygainSdkFooterMenu: IResponseMenuItem[][]
  honeygainCleanFooterMenu: IResponseMenuItem[][]
  footerReferralIoFooterMenu: IResponseMenuItem[][]
  sdkMenu?: IResponseMenuItem[]
  reusableBlocks: TReusableBlock
  languages: ILanguageSwitcherLanguage[]
  translations: Record<string, string>
  locale: string
  sessionId: string
  isFrontPage: boolean
  isHeroCampaignCTAVisible: boolean
  pageId: number
}

export let store: IStore = {
  menu: [],
  honeygainCleanMenu: [],
  honeygainReferralMeMenu: [],
  honeygainReferralIoMenu: [],
  carebuzzMenu: [],
  sdkMenu: [],
  footerMenu: [[], [], [], []],
  carebuzzFooterMenu: [[], [], [], []],
  swarmbytesFooterMenu: [[], [], [], []],
  honeygainSdkFooterMenu: [[], [], [], []],
  honeygainCleanFooterMenu: [[], [], [], []],
  footerReferralIoFooterMenu: [[], [], [], []],
  reusableBlocks: new Map(),
  languages: [],
  translations: {},
  locale: 'en',
  sessionId: '',
  isFrontPage: false,
  isHeroCampaignCTAVisible: false,
  pageId: 0,
}

export const updateStore = (newStore: IStore) => {
  store = newStore
}
